import {Nullable} from '@fl/cmsch-fe-library';

/** Redux form name for the create-criteria-list form. */
export const createCriteriaListFormName = 'createCriteriaList';

/** Form values used by the create-criteria-list form. */
export interface CreateCriteriaListFormValues {
    /** New criteria list name. */
    name: Nullable<string>;
}

/** Initial create-criteria-list form values. */
export const initialCreateCriteriaListFormValues: CreateCriteriaListFormValues = {
    name: null,
};
